import React, { Component } from 'react';
import actions from '../actions';
import entityActions from '../../../baseApp/entities/actions';
import sharedActions from '../../../baseApp/shared/actions';
import interfaceActions from '../../../baseApp/interfaces/actions';
import { connect } from 'react-redux';
import MeetingRoomsForm from './../components/MeetingRoomsForm';
import Validators from '../../../baseApp/shared/utils/Validators';
import { I18n } from 'react-redux-i18n';
import _ from '../../../baseApp/shared/utils/ObjectUtils';
import {getInitialStateForEntityType, entitiesAllowedParents} from "../../otherEntities/utils";
import {availableEntityTypes} from "../../otherEntities/utils";
import DateTimeUtils from "../../../baseApp/shared/utils/DateTimeUtils";

class MeetingRoomsFormContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            viewMode: !_.isNilOrEmpty(props.meetingRoomId),
            editMode: false,
            createMode: _.isNilOrEmpty(props.meetingRoomId),
            alert: {
                show: false
            },
            meetingRoomFormData: {
                name: {
                    value: undefined,
                    error: undefined,
                    required: true
                },
                parent: {
                    value: undefined,
                    error: undefined,
                    required: true
                },
                subFormData: getInitialStateForEntityType(availableEntityTypes.meetingRoom)
            }
        }
    }

    componentWillUnmount() {
        this.props.resetMeetingRoomsForm();     
        this.props.updateCustomTitle();
        this.props.updateCustomBreadcrumbs();   
    }

    componentDidMount() {
       // console.log(this.props.location.state.searchFieldsData)
        const {
            meetingRoomId,
            getMeetingRoomData,
            getEntityList,
            getMeetingRoomProviderList,
            getEntityLastReadings,
            getScheduledEventsForCalendar
        } = this.props;

        if (meetingRoomId) {
            getMeetingRoomData(meetingRoomId);
        }
        getMeetingRoomProviderList();
        getEntityList({
            type: entitiesAllowedParents(availableEntityTypes.meetingRoom)
        });
        getEntityLastReadings(meetingRoomId);

        const startDate = DateTimeUtils.getMomentForBeginningOfWeek().getTime();
        const endDate = DateTimeUtils.getMomentForEndOfWeek().getTime();

        getScheduledEventsForCalendar(meetingRoomId, startDate, endDate);
    };

    componentWillReceiveProps(nextProps) {
        //Handle Error, Edit and Create
        if(this.props.loadingCreateRequest && !nextProps.loadingCreateRequest) {
            if(nextProps.meetingRoomWasCreated) {
                this.handleMeetingRoomCreateSuccess();
            } else {
                this.handleMeetingRoomCreateError(nextProps.error)
            }
        } else if(this.props.loadingDeleteRequest && !nextProps.loadingDeleteRequest) {
            if(nextProps.meetingRoomWasDeleted) {
                this.handleMeetingRoomDeleteSuccess();
            } else {
                this.handleMeetingRoomDeleteError(nextProps.error)
            }
        } else  if(this.props.loadingEditRequest && !nextProps.loadingEditRequest) {
            if(nextProps.meetingRoomWasEdited) {
                this.handleMeetingRoomEditSuccess();
            } else {
                this.handleMeetingRoomEditError(nextProps.error);
            }
        } else if (this.props.loadingMeetingRoom && !nextProps.loadingMeetingRoom) {
            this.handleMeetingRoomLoadingCompleted(nextProps.meetingRoomData)
        }
    };

    handleMeetingRoomLoadingCompleted = meetingRoomData => {
        const { 
            updateCustomTitle,
            updateCustomBreadcrumbs
        } = this.props;

        updateCustomTitle(meetingRoomData.name);
        updateCustomBreadcrumbs([{
            link: "/meetingRooms",
            name: I18n.t('routes.meetingRooms')
        }, {
            link: "/meetingRooms/" + meetingRoomData.id,
            name: meetingRoomData.name
        }]);

        this.setState({
            meetingRoomFormData: {
                ...this.state.meetingRoomFormData,
                ...Object.entries(meetingRoomData).reduce(
                    (acc, [key, value]) => {
                        if (this.state.meetingRoomFormData[key]) {
                            return {
                                ...acc,
                                [key]: {
                                    ...acc[key],
                                    ...this.state.meetingRoomFormData[key],
                                    value: value
                                }
                            }
                        } else {
                            return acc;
                        }
                    }, {}),
                subFormData: getInitialStateForEntityType(meetingRoomData.type, meetingRoomData)
            }
        })
    };

    handleFieldChange = (id, value) => {
        this.setState({
            meetingRoomFormData: {
                ...this.state.meetingRoomFormData,
                [id]: {
                    ...this.state.meetingRoomFormData[id],
                    value: value
                }
            }
        }, () => {
            if (_.has(this.state.meetingRoomFormData[id], 'required')) {
                this.validateField(id, false);
            }
        })
    };

    handleSubFormFieldChange = (id, value) => {
        if(id === "hasQuickBook") {
            this.setState({
                meetingRoomFormData: {
                    ...this.state.meetingRoomFormData,
                    subFormData: {
                        ...this.state.meetingRoomFormData.subFormData,
                        [id]: {
                            ...this.state.meetingRoomFormData.subFormData[id],
                            value: value
                        },
                        maxMeetingTime: {
                            value: "",
                            error: undefined,
                            required: value
                        },
                        minMeetingTime: {
                            value: "",
                            error: undefined,
                            required: value
                        },
                        quickBookPeriod: {
                            value: "",
                            error: undefined,
                            required: value
                        },
                        allowCancelQuickBook: {
                            value: false,
                            error: undefined,
                            required: value
                        }
                    }
                }
            }, () => {
                if (_.has(this.state.meetingRoomFormData.subFormData[id], 'required')) {
                    this.validateField(id, true);
                }
            })
        } else {
            this.setState({
                meetingRoomFormData: {
                    ...this.state.meetingRoomFormData,
                    subFormData: {
                        ...this.state.meetingRoomFormData.subFormData,
                        [id]: {
                            ...this.state.meetingRoomFormData.subFormData[id],
                            value: value
                        }
                    }
                }
            },() => {
                if (_.has(this.state.meetingRoomFormData.subFormData[id], 'required')) {
                    this.validateField(id, true);
                }
            })
        }
    };

    validateField = (key, subFormField) => {
        let meetingRoomFormData;
        if(!subFormField) {
            meetingRoomFormData = this.state.meetingRoomFormData;
        } else {
            meetingRoomFormData = this.state.meetingRoomFormData.subFormData;
        }
        let error = null;
        switch (key) {
            case "email":
                error = !Validators.email(meetingRoomFormData[key].value) ? I18n.t('meetingRooms.errors.invalidEmail') : undefined;
                break;
            case "logoUrl":
                error = !Validators.isUrl(meetingRoomFormData[key].value) ? I18n.t('entities.errors.invalidUrl') : undefined;
                break;
            case "area":
                error = !Validators.isInteger(meetingRoomFormData[key].value) ? I18n.t('entities.errors.area') : undefined;
                break;
            case "capacity":
                error = !Validators.isInteger(meetingRoomFormData[key].value) ? I18n.t('entities.errors.invalidCapacity') : undefined;
                break;
            case "tolerancePeriod":
                error = !Validators.isInteger(meetingRoomFormData[key].value) ? I18n.t('entities.errors.tolerance') : undefined;
                break;
            case "checkInOpen":
                error = !Validators.isInteger(meetingRoomFormData[key].value) ? I18n.t('entities.errors.checkInOpen') : undefined;
                break;
            case "calendarDepth":
                error = !Validators.isInteger(meetingRoomFormData[key].value) ? I18n.t('entities.errors.calendarDepth') : undefined;
                break;
            case "quickBookPeriod":
                error = !Validators.isInteger(meetingRoomFormData[key].value) ? I18n.t('entities.errors.quickBookPeriod') : undefined;
                break;
            case "minimumSchedulingPeriod":
                error = !Validators.isInteger(meetingRoomFormData[key].value) ? I18n.t('entities.errors.minimumSchedulingPeriod') : undefined;
                break;
            case "maxMeetingTime":
                error = !Validators.isInteger(meetingRoomFormData[key].value) ? I18n.t('entities.errors.maxMeetingTime') : undefined;
                break;
            case "minMeetingTime":
                error = !Validators.isInteger(meetingRoomFormData[key].value) ? I18n.t('entities.errors.minMeetingTime') : undefined;
                break;
            default:
                if (!_.isNilOrEmpty(meetingRoomFormData[key].error) &&
                    meetingRoomFormData[key].required &&
                    !_.isNilOrEmpty(meetingRoomFormData[key].value)) {
                    error = undefined;
                } else if (meetingRoomFormData[key].required &&
                    _.isNilOrEmpty(meetingRoomFormData[key].value)) {
                    error = I18n.t('forms.errors.emptyRequiredField')
                }
                break;
        }
            if (error !== meetingRoomFormData[key].error) {
                meetingRoomFormData[key].error = error;
                let fullDataForm;
                if(subFormField){
                    fullDataForm = this.state.meetingRoomFormData;
                    fullDataForm.subFormData = meetingRoomFormData;
                } else {
                    fullDataForm = meetingRoomFormData;
                }
                this.setState({
                    fullDataForm,
                });
            }
    };

    handleOnFieldBlur = (key) => {
        this.validateField(key)
    };

    handleSubmitClick = () => {
        let { editMode, meetingRoomFormData } = this.state;
        const { meetingRoomId, editMeetingRoom, createMeetingRoom } = this.props;
        let formHasErrors = false;

        _.forOwn(meetingRoomFormData, (field, key) => {
            if(key === 'subFormData') {
                _.forOwn(field, subFormField => {
                    if (subFormField.required && _.isNilOrEmpty(subFormField.value)) {
                        subFormField.error = I18n.t('forms.errors.emptyRequiredField');
                        formHasErrors = true;
                    } else if(!_.isNilOrEmpty(subFormField.error)) {
                        formHasErrors = true;
                    } else {
                        subFormField.error = undefined;
                    }
                });
            } else {
                if((field.required && _.isNilOrEmpty(field.value))) {
                    field.error = I18n.t('forms.errors.emptyRequiredField');
                    formHasErrors = true;
                } else if(!_.isNilOrEmpty(field.error)) {
                    formHasErrors = true;
                } else {
                    field.error = undefined;
                }
            }
        });

        if (!formHasErrors) {
            const formDataToBeSubmitted = Object.entries(meetingRoomFormData).reduce((acc, [key, formField]) => {
                if(key === 'subFormData') {
                    const subFormData = Object.entries(formField).reduce((subFormAcc, [subFormKey, subFormField]) => {
                        return {
                            ...subFormAcc,
                            [subFormKey]: subFormField.value
                        }
                    }, {});
                    return {
                        ...acc,
                        ...subFormData
                    }
                }
                return {
                    ...acc,
                    [key]: formField.value
                }
            }, {});

            const meetingRoomName = formDataToBeSubmitted.name;
            if (editMode) {
                this.setState({
                    alert: {
                        show: true,
                        type: "warning",
                        title: I18n.t('meetingRooms.alerts.edit.title'),
                        html: I18n.t('meetingRooms.alerts.edit.text', { meetingRoom: meetingRoomName }),
                        confirmButtonText: I18n.t('forms.submit'),
                        cancelButtonText: I18n.t('forms.cancel'),
                        onCancel: this.hideAlert,
                        onConfirm: () => {
                            editMeetingRoom(meetingRoomId, formDataToBeSubmitted)
                        }
                    }
                })
            } else {
                this.setState({
                    alert: {
                        show: true,
                        type: "warning",
                        title: I18n.t('meetingRooms.alerts.create.title'),
                        html: I18n.t('meetingRooms.alerts.create.text', { meetingRoom: meetingRoomName }),
                        confirmButtonText: I18n.t('forms.submit'),
                        cancelButtonText: I18n.t('forms.cancel'),
                        onCancel: this.hideAlert,
                        onConfirm: () => {
                            createMeetingRoom(formDataToBeSubmitted)
                        }
                    }
                })
            }
        } else {
            this.setState({
                meetingRoomFormData,
            });
        }
    };

    handleEditClick = () => {
        const { editMode } = this.state;
        const { meetingRoomData } = this.props;

        if (editMode) {
            this.setState({
                editMode: false,
                viewMode: true,
                meetingRoomFormData: {
                    ...Object.entries(meetingRoomData).reduce((acc, [key, formField]) => {
                        if (meetingRoomData[key]) {
                            return {
                                ...acc,
                                [key]: {
                                    ...acc[key],
                                    ...this.state.meetingRoomFormData[key],
                                    value: meetingRoomData[key],
                                    error: undefined
                                }
                            }
                        } else {
                            return acc;
                        }
                    }, {}),
                    subFormData: getInitialStateForEntityType(meetingRoomData.type, meetingRoomData)
                }
            })
        } else {
            this.setState({
                viewMode: false,
                editMode: true
            })
        }
    };

    hideAlert = () => {
        this.setState({
            alert: {
                show: false
            }
        })
    };

    handleBackClick = () => {
        this.props.resetMeetingRoomsForm();
        //this.props.history.push('/meetingRooms');

        this.props.history.push({
            pathname: '/meetingRooms',
            state: { 
                searchFieldsData : this.props.location.state.searchFieldsData, 
                universalSearchField :  this.props.location.state.universalSearchField
            }
          })
    };

    handleDeleteClick = () => {
        const { meetingRoomId, deleteMeetingRoom } = this.props;
        const {
            meetingRoomFormData: {
                name: {
                    value: name
                }
            }
        } = this.state;

        this.setState({
            alert: {
                show: true,
                type: "warning",
                title: I18n.t('meetingRooms.alerts.delete.title'),
                html: I18n.t('meetingRooms.alerts.delete.text', { meetingRoom: name }),
                confirmButtonText: I18n.t('forms.delete'),
                cancelButtonText: I18n.t('forms.cancel'),
                onCancel: this.hideAlert,
                onConfirm: () => {
                    deleteMeetingRoom(meetingRoomId)
                }
            }
        })
    };

    handleMeetingRoomDeleteSuccess = () => {
        const {
            meetingRoomFormData: {
                name: {
                    value: name
                }
            }
        } = this.state;

        this.setState({
            alert: {
                show: true,
                type: 'success',
                title: I18n.t('meetingRooms.alerts.delete.success.title'),
                html: I18n.t('meetingRooms.alerts.delete.success.text', { meetingRoom: name }),
                confirmButtonText: I18n.t('forms.ok'),
                onCancel: this.handleBackClick,
                onConfirm: this.handleBackClick
            }
        })
    };

    handleMeetingRoomDeleteError = error => {
        this.setState({
            alert: {
                show: true,
                type: 'error',
                title: I18n.t('meetingRooms.alerts.delete.error.title'),
                html: I18n.t('meetingRooms.alerts.delete.error.text'),
                confirmButtonText: I18n.t('forms.ok'),
                onConfirm: this.hideAlert
            }
        })
    };

    handleMeetingRoomCreateSuccess = () => {
        const {
            meetingRoomFormData: {
                name: {
                    value: name
                }
            }
        } = this.state;

        this.setState({
            alert: {
                show: true,
                type: 'success',
                title: I18n.t('meetingRooms.alerts.create.success.title'),
                html: I18n.t('meetingRooms.alerts.create.success.text', { meetingRoom: name }),
                confirmButtonText: I18n.t('forms.ok'),
                onCancel: this.handleBackClick,
                onConfirm: this.handleBackClick
            }
        })
    };

    handleMeetingRoomCreateError = error => {
        this.setState({
            alert: {
                show: true,
                type: 'error',
                title: I18n.t('meetingRooms.alerts.create.error.title'),
                html: error ? error : I18n.t('meetingRooms.alerts.create.error.text'),
                confirmButtonText: I18n.t('forms.ok'),
                onConfirm: this.hideAlert
            }
        })
    };

    handleMeetingRoomEditSuccess = () => {
        const {
            meetingRoomFormData: {
                name: {
                    value: name
                }
            }
        } = this.state;

        this.setState({
            alert: {
                show: true,
                type: 'success',
                title: I18n.t('meetingRooms.alerts.edit.success.title'),
                html: I18n.t('meetingRooms.alerts.edit.success.text', { meetingRoom: name }),
                confirmButtonText: I18n.t('forms.ok'),
                onCancel: this.handleBackClick,
                onConfirm: this.handleBackClick
            }
        })
    };

    handleMeetingRoomEditError = error => {
        this.setState({
            alert: {
                show: true,
                type: 'error',
                title: I18n.t('meetingRooms.alerts.edit.error.title'),
                html: error ? error : I18n.t('meetingRooms.alerts.edit.error.text'),
                confirmButtonText: I18n.t('forms.ok'),
                onConfirm: this.hideAlert
            }
        })
    };

    render() {
        const { 
            createMode, 
            editMode, 
            viewMode, 
            meetingRoomFormData,
            alert 
        } = this.state;

        const {
            meetingRoomId,
            entityList, 
            loadingDeleteRequest, 
            loadingCreateRequest, 
            loadingEditRequest, 
            providerList, 
            entityLastReadings, 
            meetingRoomScheduleForCalendar, 
            meetingRoomData
        } = this.props;
        console.log("roomData",meetingRoomData);
        console.log("roomFormData", meetingRoomData);
        return <MeetingRoomsForm
            meetingRoomId={meetingRoomId}
            editMode={editMode}
            createMode={createMode}
            viewMode={viewMode}
            alert={{
                ...alert,
                loading: loadingDeleteRequest || loadingCreateRequest || loadingEditRequest
            }}
            meetingRoomFormData={meetingRoomFormData}
            meetingRoomData={meetingRoomData}
            entityList={entityList}
            entityLastReadings={entityLastReadings}
            providerList={providerList}
            eventsForCalendar={meetingRoomScheduleForCalendar}
            handleSubFormFieldChange={this.handleSubFormFieldChange}
            handleFieldChange={this.handleFieldChange}
            handleOnFieldBlur={this.handleOnFieldBlur}
            handleSubmitClick={this.handleSubmitClick}
            handleEditClick={this.handleEditClick}
            handleDeleteClick={this.handleDeleteClick}
            handleBackClick={this.handleBackClick}
        />
    }
}

const mapStateToProps = ({ meetingRoomsReducer, entitiesReducer, interfacesReducer }) => {
    return {
        entityList: entitiesReducer.entityList,
        providerList: meetingRoomsReducer.providerList,

        meetingRoomData: meetingRoomsReducer.meetingRoomData,
        loadingMeetingRoom: meetingRoomsReducer.loading,
        loadingEntityList: entitiesReducer.loadingListRequest,
        loadingMeetingRoomProviderList: meetingRoomsReducer.loadingListRequest,
        error: meetingRoomsReducer.error,

        loadingDeleteRequest: meetingRoomsReducer.loadingDeleteRequest,
        meetingRoomWasDeleted: meetingRoomsReducer.meetingRoomWasDeleted,

        loadingCreateRequest: meetingRoomsReducer.loadingCreateRequest,
        meetingRoomWasCreated: meetingRoomsReducer.meetingRoomWasCreated,

        loadingEditRequest: meetingRoomsReducer.loadingEditRequest,
        meetingRoomWasEdited: meetingRoomsReducer.meetingRoomWasEdited,

        loadingCalendarEvents: meetingRoomsReducer.loadingCalendarEvents,
        meetingRoomScheduleForCalendar: meetingRoomsReducer.meetingRoomScheduleForCalendar,

        entityLastReadings: interfacesReducer.entityLastReadings
    };
};

const mapDispatchToProps = {
    getMeetingRoomData: actions.getMeetingRoomData,
    createMeetingRoom: actions.createMeetingRoom,
    editMeetingRoom: actions.editMeetingRoom,
    deleteMeetingRoom: actions.deleteMeetingRoom,
    resetMeetingRoomsForm: actions.resetMeetingRoomsForm,
    getMeetingRoomProviderList: actions.getMeetingRoomProviderList,
    getScheduledEventsForCalendar: actions.getScheduledEventsForCalendar,
    getEntityList: entityActions.getEntityList,
    getEntityLastReadings: interfaceActions.getEntityLastReadings,

    updateCustomTitle: sharedActions.updateCustomTitle,
    updateCustomBreadcrumbs: sharedActions.updateCustomBreadcrumbs
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(MeetingRoomsFormContainer);
